module.exports = __webpack_public_path__ + "img/scene4copysub.7973af49.png";